<template>
  <div class="storefinder__infoWindow" ref="infoWindow">
    <h4>{{ store.company }}</h4>
    <small class="distance">{{ Number((store.distance).toFixed(1)) }} km</small>
    {{ store.address }}<br>
    {{ store.zip }} {{ store.city }}<br>
    <a :href="store.www" v-if="store.www">{{ store.www }}</a>
    <ul>
      <li v-for="category in store.categories">{{ category.title }}</li>
    </ul>
    <p>
      <a class="button" :href="'https://maps.google.com/?daddr=' + store._string" target="_blank">Find us</a>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'storefinder-marker',

    props: {
      map: {
        type: Object,
        required: true
      },
      store: {
        type: Object,
        required: true,
        default: {
          company: '',
          address: '',
          zip: '',
          city: '',
          phone: '',
          www: '',
          distance: -1
        }
      }
    },

    data () {
      return {
        marker: null,
        clickListener: null,
        infoWindow: null
      }
    },

    mounted () {
      if (this.store.latitude && this.store.longitude) {
        this.marker = new google.maps.Marker({
          title: this.store.company,
          position: {
            lat: parseFloat(this.store.latitude),
            lng: parseFloat(this.store.longitude)
          },
          map: this.map,
          animation: google.maps.Animation.DROP
        })

        this.infoWindow = new google.maps.InfoWindow({
          content: this.$refs.infoWindow
        })

        const self = this
        this.marker.addListener('click', function () {
          self.infoWindow.open(self.map, self.marker)
        })
      }
    },

    beforeDestroy () {
      console.log('beforeDestroy', this.store)
      const self = this
      this.marker.setMap(null)
    }
  }
</script>
